import { Component, HostBinding, Input } from '@angular/core';
import { formatDetailValue, isInternalDetailKey } from './detail-section.util';

/**
 * One label/value cell. A row with an internal key stays hidden unless `project` is set.
 * Pass `value`, or project custom content (a link, a badge) into the value.
 */
@Component({
  selector: 'app-detail-item',
  templateUrl: './detail-item.component.html',
  styleUrls: ['./detail-item.component.scss'],
  host: { class: 'detail-item' },
})
export class DetailItemComponent {
  @Input() label = '';
  @Input() wide = false;
  /** Machine key. Internal ids and slugs are hidden unless `project` is set. */
  @Input() key = '';
  /** Show this row even when `key` is an internal code or slug. */
  @Input() project = false;

  private valueSet = false;
  private raw: unknown;

  @Input()
  set value(value: unknown) {
    this.valueSet = true;
    this.raw = value;
  }

  get value(): unknown {
    return this.raw;
  }

  get hasValue(): boolean {
    return this.valueSet;
  }

  get formatted(): string {
    return formatDetailValue(this.raw);
  }

  @HostBinding('class.detail-item--wide')
  get wideClass(): boolean {
    return this.wide;
  }

  @HostBinding('class.detail-item--internal')
  get internalClass(): boolean {
    return isInternalDetailKey(this.key);
  }

  @HostBinding('class.detail-item--project')
  get projectClass(): boolean {
    return this.project;
  }
}
